import React from "react";
import PropTypes from "prop-types";
import { Blockquote } from "@wfp/ui";

import style from "./style.module.scss";

// A wrapper of the Blockquote component form WFP UI Kit
const MessageInformation = ({ children }) => (
  <div className={style.wrapper}>
    <Blockquote info>
      {children}
    </Blockquote>
  </div>
);

// propTypes for the MessageInformation component
MessageInformation.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MessageInformation;
